export const pdTranslations = {
  en: {
    t1: "🚀 Think5Whys PurpleDoor",
    t2: "Gen Z + Gen Alpha Universe",
    t3: "Built for the world's largest future-ready generations"
  },

  hi: {
    t1: "🚀 Think5Whys PurpleDoor",
    t2: "Gen Z + Gen Alpha ब्रह्मांड",
    t3: "दुनिया की सबसे बड़ी भविष्य-तैयार पीढ़ियों के लिए निर्मित"
  },

  bn: {
    t1: "🚀 Think5Whys PurpleDoor",
    t2: "Gen Z + Gen Alpha মহাবিশ্ব",
    t3: "বিশ্বের বৃহত্তম ভবিষ্যৎ-প্রস্তুত প্রজন্মের জন্য নির্মিত"
  },

  mr: {
    t1: "🚀 Think5Whys PurpleDoor",
    t2: "Gen Z + Gen Alpha विश्व",
    t3: "जगातील सर्वात मोठ्या भविष्यसज्ज पिढ्यांसाठी तयार केलेले"
  },

  gu: {
    t1: "🚀 Think5Whys PurpleDoor",
    t2: "Gen Z + Gen Alpha વિશ્વ",
    t3: "વિશ્વની સૌથી મોટી ભવિષ્ય-તૈયાર પેઢીઓ માટે બનાવાયેલ"
  },

  ta: {
    t1: "🚀 Think5Whys PurpleDoor",
    t2: "Gen Z + Gen Alpha பிரபஞ்சம்",
    t3: "உலகின் மிகப்பெரிய எதிர்காலத் தயாரான தலைமுறைகளுக்காக உருவாக்கப்பட்டது"
  },

  te: {
    t1: "🚀 Think5Whys PurpleDoor",
    t2: "Gen Z + Gen Alpha విశ్వం",
    t3: "ప్రపంచంలోని అతిపెద్ద భవిష్యత్-సిద్ధమైన తరాల కోసం నిర్మించబడింది"
  },

  kn: {
    t1: "🚀 Think5Whys PurpleDoor",
    t2: "Gen Z + Gen Alpha ವಿಶ್ವ",
    t3: "ಜಗತ್ತಿನ ಅತಿದೊಡ್ಡ ಭವಿಷ್ಯ-ಸಿದ್ಧ ತಲೆಮಾರುಗಳಿಗಾಗಿ ನಿರ್ಮಿಸಲಾಗಿದೆ"
  },

  ml: {
    t1: "🚀 Think5Whys PurpleDoor",
    t2: "Gen Z + Gen Alpha ലോകം",
    t3: "ലോകത്തിലെ ഏറ്റവും വലിയ ഭാവി-സജ്ജമായ തലമുറകൾക്കായി നിർമ്മിച്ചത്"
  },

  pa: {
    t1: "🚀 Think5Whys PurpleDoor",
    t2: "Gen Z + Gen Alpha ਬ੍ਰਹਿਮੰਡ",
    t3: "ਦੁਨੀਆ ਦੀਆਂ ਸਭ ਤੋਂ ਵੱਡੀਆਂ ਭਵਿੱਖ-ਤਿਆਰ ਪੀੜ੍ਹੀਆਂ ਲਈ ਤਿਆਰ ਕੀਤਾ ਗਿਆ"
  },

  as: {
    t1: "🚀 Think5Whys PurpleDoor",
    t2: "Gen Z + Gen Alpha বিশ্ব",
    t3: "বিশ্বৰ সৰ্ববৃহৎ ভৱিষ্যৎ-প্ৰস্তুত প্ৰজন্মসমূহৰ বাবে নিৰ্মিত"
  },

  ur: {
    t1: "🚀 Think5Whys PurpleDoor",
    t2: "Gen Z + Gen Alpha کائنات",
    t3: "دنیا کی سب سے بڑی مستقبل کے لیے تیار نسلوں کے لیے بنایا گیا"
  },

  ar: {
    t1: "🚀 Think5Whys PurpleDoor",
    t2: "عالم Gen Z و Gen Alpha",
    t3: "مبني لأكبر الأجيال الجاهزة للمستقبل في العالم"
  },

  ja: {
    t1: "🚀 Think5Whys PurpleDoor",
    t2: "Gen Z + Gen Alpha ユニバース",
    t3: "世界最大の未来志向世代のために構築"
  },

  zh: {
    t1: "🚀 Think5Whys PurpleDoor",
    t2: "Gen Z + Gen Alpha 宇宙",
    t3: "专为全球最大、面向未来的一代打造"
  },

  ko: {
    t1: "🚀 Think5Whys PurpleDoor",
    t2: "Gen Z + Gen Alpha 유니버스",
    t3: "세계 최대의 미래 준비 세대를 위해 구축되었습니다"
  },

  es: {
    t1: "🚀 Think5Whys PurpleDoor",
    t2: "Universo Gen Z + Gen Alpha",
    t3: "Construido para las generaciones más grandes y preparadas para el futuro del mundo"
  },

  pt: {
    t1: "🚀 Think5Whys PurpleDoor",
    t2: "Universo Gen Z + Gen Alpha",
    t3: "Construído para as maiores gerações preparadas para o futuro do mundo"
  },

  fr: {
    t1: "🚀 Think5Whys PurpleDoor",
    t2: "Univers Gen Z + Gen Alpha",
    t3: "Conçu pour les plus grandes générations prêtes pour l’avenir du monde"
  },

  id: {
    t1: "🚀 Think5Whys PurpleDoor",
    t2: "Semesta Gen Z + Gen Alpha",
    t3: "Dibangun untuk generasi terbesar yang siap menghadapi masa depan"
  },

  ms: {
    t1: "🚀 Think5Whys PurpleDoor",
    t2: "Alam Gen Z + Gen Alpha",
    t3: "Dibina untuk generasi terbesar yang bersedia menghadapi masa depan"
  },

  de: {
    t1: "🚀 Think5Whys PurpleDoor",
    t2: "Gen Z + Gen Alpha Universum",
    t3: "Für die größten zukunftsbereiten Generationen der Welt entwickelt"
  },

  tr: {
    t1: "🚀 Think5Whys PurpleDoor",
    t2: "Gen Z + Gen Alpha Evreni",
    t3: "Dünyanın geleceğe hazır en büyük nesilleri için oluşturuldu"
  }
};